<template>
    <b-container fluid>
      <b-row>
        <b-col>
          <b-card class="mb-0">
            <h5>
              <router-link :to="{ name: 'Case', params: { id: item.id }}"><h5>{{item.name}}</h5></router-link>
            </h5>
              <div class="mb-0" v-html="item.description"> </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
</template>

<script>
export default {
  name: 'CaseSimple',
  props: ['item', 'username'],
  computed: {
    user: {
      get () {
        return this.$store.state.user
      }
    }
  }
}
</script>
